import { notifyPartnersChanged } from "../utils/dashboardStats";

const API = process.env.REACT_APP_API_URL;

export interface PartnerCountResponse {
  total: number;
}

export interface IPartner {
  _id: string;
  name: string;
  email: string;
  contactName?: string;
  active: boolean;
  lastLoginAt?: string;
  createdAt: string;
  updatedAt: string;
  projectCount?: number;
  bookCount?: number;
}

export interface PartnerDetailResponse {
  partner: IPartner;
  stats: { projectCount: number; bookCount: number; clipCount: number };
  projects: Array<{ _id: string; projectName: string; createdAt: string }>;
  books: Array<{ _id: string; title: string; projectId: string; createdAt: string }>;
  recentActivity: Array<{
    _id: string;
    clipName: string;
    chapter: string;
    bookTitle: string;
    createdAt: string;
  }>;
}

const jsonFetch = async (url: string, options?: RequestInit) => {
  const res = await fetch(url, {
    ...options,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options?.headers || {}),
    },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || data.error || "Request failed");
  return data;
};

export const listPartners = (): Promise<IPartner[]> =>
  jsonFetch(`${API}/partners`); 

export const getPartnerCount = (): Promise<PartnerCountResponse> =>
  jsonFetch(`${API}/partners/count`);

export const createPartner = async (payload: {
  name: string;
  email: string;
  contactName?: string;
}): Promise<{ partner: IPartner; emailSent: boolean; temporaryPassword?: string }> => {
  const result = await jsonFetch(`${API}/partners`, { method: "POST", body: JSON.stringify(payload) });
  notifyPartnersChanged();
  return result;
};

export const getPartner = (partnerId: string): Promise<PartnerDetailResponse> =>
  jsonFetch(`${API}/partners/${partnerId}`);

export const getPartnerList = async(page:number,limit:number)=>{
   const res = await jsonFetch(`${API}/partners/get-partners?page=${page}&limit=${limit}`);
   
   return res
}

export const deletePartnerApi = async(id:any)=>{
   const res = await jsonFetch(`${API}/partners/delete-partner`, { method: "POST",body:JSON.stringify({ id }) });
   return res;
}

export const updatePartner = (
  partnerId: string,
  payload: { name?: string; email?: string; contactName?: string },
): Promise<IPartner> =>
  jsonFetch(`${API}/partners/${partnerId}`, { method: "PUT", body: JSON.stringify(payload) });

export const setPartnerStatus = async (
  partnerId: string,
  active: boolean,
): Promise<IPartner> => {
  const result = await jsonFetch(`${API}/partners/${partnerId}/status`, {
    method: "PATCH",
    body: JSON.stringify({ active }),
  });
  notifyPartnersChanged();
  return result;
};

export const resetPartnerPassword = (
  partnerId: string,
): Promise<{ message: string; emailSent: boolean; temporaryPassword?: string }> =>
  jsonFetch(`${API}/partners/${partnerId}/reset-password`, { method: "POST" });


  export const getNotifications = async(userId:string,search:string)=>{
const result = await jsonFetch(`${API}/partners/notifications/${userId}?search=${search}`)
  
return result
}

export const markAllAsRead = async(userId:string)=>{
  const response = await jsonFetch(`${API}/partners/mark-as-read`,{method:"POST",body:JSON.stringify({userId})});
  return response
}

export const deleteNotification = async(id:string)=>{
  const response = await jsonFetch(`${API}/partners/delete-notification`,{method:"POST",body:JSON.stringify({id})});
  return response
}